import NotFound from "components/404/NotFound.component";
import SeeAllCardItems from "components/order-card/SeeAllCardItems.component";
import { uniqueId } from "lodash";
import DeleteUserPage from "pages/delete-user/delete-user.page";
import ForgotPassword from "pages/forgot-password/forgot-password.page";
import PrivacyPolicy from "pages/privacy-policy/privacy-policy.page";
import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { SignUp } from "../../pages/auth-page/auth-page.page";
import OurStory from "../../pages/our-story/our-story.page";
import { setMainClient } from "../../store/actions/user.action";
import { getAuthPath } from "../../utils/common/common.utils";
import { ROUTES } from "../../utils/constants/route.constants";
import { lazyRetry } from "../../utils/lazy-retry/lazy-retry.util";
import withSuspenseFallback from "../with-suspense-fallback/WithSuspenseFallback.component";

const HomePage = withSuspenseFallback(
  lazyRetry(() => import("../../pages/home-page/home.page"))
);

const WishListPage = withSuspenseFallback(
  lazyRetry(() => import("pages/wish-list-page/wish-list.page"))
);
const DivisionDetails = withSuspenseFallback(
  lazyRetry(() => import("../../pages/division-details/division-details.page"))
);
const OurShop = withSuspenseFallback(
  lazyRetry(() => import("../../pages/our-shop/our-shop"))
);
const NewLogin = withSuspenseFallback(
  lazyRetry(() => import("../auth/login/Login.component"))
);
const YourOrders = withSuspenseFallback(
  lazyRetry(() => import("../../pages/your-orders/your-orders.page"))
);

const CartPage = withSuspenseFallback(
  lazyRetry(() => import("../../pages/cart-page/cart.page"))
);

const ProductDetail = withSuspenseFallback(
  lazyRetry(() => import("../../pages/product-detail/product-detail.page"))
);

function About() {
  return <div>This is the about page</div>;
}
const AppRouter = () => {
  useEffect(() => {
    setMainClient();
  }, []);

  return (
    <Routes>
      <Route path={ROUTES.HOME} element={<HomePage />} exact />
      <Route
        path={ROUTES.DIVISION_ID}
        element={<DivisionDetails />}
        exact
        key={uniqueId()}
      />
      <Route
        path={ROUTES.OVERVIEW}
        element={<DivisionDetails />}
        exact
        key={uniqueId()}
      />
      <Route path={ROUTES.ABOUT} element={<About />} exact />
      <Route path={ROUTES.SHOP} element={<OurShop />} exact />
      <Route path={ROUTES.SHOP_CATEGORY_ID} element={<OurShop />} exact />
      <Route path={ROUTES.SHOP_ID} element={<ProductDetail />} />
      <Route
        path={ROUTES.SHOP_CATEGORY_PRODUCT_ID}
        element={<ProductDetail />}
      />
      <Route path={ROUTES.CART} element={<CartPage />} exact />
      <Route path={getAuthPath()} element={<NewLogin />} exact />
      <Route path={getAuthPath(false)} element={<SignUp />} exact />
      <Route path={ROUTES.YOUR_ORDERS} element={<YourOrders />} />
      <Route path={ROUTES.YOUR_ORDERS_ID} element={<SeeAllCardItems />} />
      <Route path={ROUTES.OUR_STORY} element={<OurStory />} />
      <Route path={ROUTES.WISH_LIST} element={<WishListPage />} />
      <Route path={ROUTES.FORGOT_PASSWORD} element={<ForgotPassword />} />
      <Route path={ROUTES.DELETE_USER} element={<DeleteUserPage />} />
      <Route path={ROUTES.PRIVACY_POLICY} element={<PrivacyPolicy />} />

      {/* <Route path="*" element={<NoMatch />} /> */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRouter;
